import { jsx as _jsx } from "react/jsx-runtime";
import Card from "@mui/material/Card";
import { styled } from "@mui/material/styles";
import { useCsAttribute, useCsValue, useLocalOptionSelected, } from "@plansoft-configuration-renderer/framework";
import { ThumbnailActionArea } from "./ThumbnailActionArea";
import { ThumbnailValueComponentsProvider } from "./ThumbnailValueComponentsProvider";
/**
 * Wrapper for attributes with support for theming
 */
const MuiThumbnailItemCard = styled(Card, {
    name: "MuiThumbnailItemCard",
    slot: "root",
    shouldForwardProp: (prop) => prop !== "disabled",
})(({ disabled }) => (Object.assign({ height: "100%" }, (disabled && {
    pointerEvents: "none",
    opacity: 0.5,
}))));
/**
 * Renders basic wrapper around the content
 */
export function ThumbnailItem(props) {
    // there is a isSelected value but it does not work with local values
    const isSelected = useLocalOptionSelected();
    const attribute = useCsAttribute();
    const value = useCsValue();
    const isAttributeDisabled = !attribute.isAllowed;
    const isValueDisabled = !value.isAllowed || !value.isActive;
    const cardDisabled = !isAttributeDisabled && isValueDisabled;
    // Note: do not change "elevation" property of Card/Paper since it interferes with "raised"
    return (_jsx(MuiThumbnailItemCard, { raised: isSelected, disabled: cardDisabled, children: _jsx(ThumbnailValueComponentsProvider, { children: _jsx(ThumbnailActionArea, { children: props.children }) }) }));
}
//# sourceMappingURL=ThumbnailItem.js.map